export const voidCallback = () => undefined;
export const asyncVoidCallback = () =>
    new Promise((resolve) => resolve(undefined));
